import {
  CandidateAssessmentsBuilder,
  GetCandidateAssessmentsInput,
  GetCandidateAssessmentsOutput,
} from '../candidate-assessments.types';

export const getCandidateAssessments = (builder: CandidateAssessmentsBuilder) =>
  builder.query<GetCandidateAssessmentsOutput, GetCandidateAssessmentsInput>({
    query: ({ candidateId }) => ({
      url: `candidate-assessments/candidate/${candidateId}/details`,
      method: 'GET',
    }),
    providesTags: ['CandidateAssessments'],
  });
